import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable()
export class UrlEnvService {
  // prod urls
  loginUrl;
  userInfoUrl;
  accountInfoUrl;
  configUrl;
  guideUrl;
  statsUrl;
  consoleUrl;
  dataQueryUrl;
  dataQueryUrlSideNav;

  constructor() {
      this.guideUrl = environment.guideUrl;
      this.statsUrl = environment.statsUrl;
      this.dataQueryUrl = environment.dataQueryUrl;
      this.dataQueryUrlSideNav = environment.dataQueryUrlSideNav;
  }

  getLoginUrl() {
    return this.loginUrl;
  }

  getConfigUrl() {
    return this.configUrl;
  }

  getUserInfoUrl() {
    return this.userInfoUrl;
  }

  getStatsUrl() {
    return this.statsUrl;
  }

  getDataQueryUrl() {
    return this.dataQueryUrl;
  }

  getDataQueryUrlSideNav() {
    return this.dataQueryUrlSideNav;
  }

  getGuideUrl() {
    return this.guideUrl;
  }

  getConsoleUrl() {
    return this.consoleUrl;
  }

  getAccountInfoUrl() {
    return this.accountInfoUrl;
  }

}



// WEBPACK FOOTER //
// ./src/app/common/services/url-env.service.ts